import { gql } from 'react-apollo'

const verifyTicketNumberQuery = gql`
  query verifyTicketNumber($eventId: MongoID!, $number: Int!) {
    checkTicketNumber(eventId: $eventId, number: $number)
  }
`

export default verifyTicketNumberQuery



// WEBPACK FOOTER //
// ./src/App/graphql/queries/verifyTicketNumber.js